import { html, css, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';

import { nsFormFieldStyles, nsLayoutStyles } from '../../../ns-styles/index.js';
import { renderFormField } from '../../../helpers/form-field.js';
import NSJobComponent from '../job.js';
import JobSchema from '../../../models/job-schema.js';
import '@awesome.me/webawesome/dist/components/button/button.js';
import definition from '@job-schemas/task.json';
import { jobSchema } from '../job-schema.js';

// A generic task: read what to do, do it, mark it done with an optional note
@customElement(NSTask.is)
export default class NSTask extends NSJobComponent {
  static get is() {
    return 'ns-task';
  }

  @state()
  private __note = '';

  static get schema(): JobSchema {
    return jobSchema(definition, { outcomes: { done: { type: 'hidden' } } });
  }

  static styles = [
    nsLayoutStyles,
    nsFormFieldStyles,
    ...super.styles,
    css`
      .content {
        display: flex;
        flex-direction: column;
        gap: var(--wa-space-m);
        height: 100%;
      }

      .instructions {
        white-space: pre-wrap;
      }

      textarea {
        width: 100%;
        min-height: 5em;
      }
    `,
  ];

  private async __done() {
    try {
      this.loading('Marking it done');
      // An empty optional value counts as missing, so a blank note is left out
      await this.outcome('done', this.__note.trim() ? { NOTE: this.__note.trim() } : {});
      this.loaded();
    } catch (err) {
      this.loaded();
      this.failJob(err, 'Unable to mark the task done');
    }
  }

  renderActions() {
    return html`
      <wa-button variant="brand" type="button" @click=${() => this.__done()}>Done</wa-button>
    `;
  }

  render() {
    const instructions = this.job.inputValues?.INSTRUCTIONS;
    return html`
      <div class="content">
        ${typeof instructions === 'string' && instructions
          ? html`
              <p class="instructions">${instructions}</p>
            `
          : nothing}
        ${renderFormField({
          id: 'task-note',
          label: 'Note (optional)',
          control: html`
            <textarea
              id="task-note"
              maxlength="2000"
              .value=${this.__note}
              @input=${(e: Event) => (this.__note = (e.target as HTMLTextAreaElement).value)}
            ></textarea>
          `,
        })}
      </div>
    `;
  }
}
